// Utility function to convert decimal to kitchen-style fraction string
// Supports common kitchen fractions (e.g., 1/2, 1/4, 3/4, etc.)
const decimalToFraction = (value) => {
  if (!value) return "";
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  const whole = Math.floor(num);
  const frac = num - whole;
  // Common kitchen fractions
  const fractions = [
    { value: 0.125, str: "1/8" },
    { value: 0.25, str: "1/4" },
    { value: 0.333, str: "1/3" },
    { value: 0.375, str: "3/8" },
    { value: 0.5, str: "1/2" },
    { value: 0.625, str: "5/8" },
    { value: 0.666, str: "2/3" },
    { value: 0.75, str: "3/4" },
    { value: 0.875, str: "7/8" },
  ];
  let closest = null;
  let minDiff = 1;
  fractions.forEach((f) => {
    const diff = Math.abs(frac - f.value);
    if (diff < minDiff) {
      minDiff = diff;
      closest = f;
    }
  });
  let result = "";
  if (whole > 0) result += whole;
  if (closest && minDiff < 0.08) {
    result += (whole > 0 ? " " : "") + closest.str;
  } else if (whole === 0) {
    // If no whole part and not close to a fraction, show decimal
    result = num.toString();
  }
  return result.trim();
};

export default decimalToFraction;
